<template>
  <div class="pBox">
    <div class="form-box">
      <div class="left">
        <form class="form-horizontal">
          <div class="form-group">
            <label class="col-sm-3 control-label">学院名称</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                placeholder="学院名称"
                disabled
                v-model="data.lqyx"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">现系部名称</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                placeholder="现系部名称"
                disabled
                v-model="data.dept"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">现专业名称</label>
            <div class="col-sm-9">
              <input
                type="text"
                class="form-control"
                placeholder="现专业名称"
                disabled
                v-model="data.zymc"
              />
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">
              调整系部名称
              <i>*</i>
            </label>
            <div class="col-sm-9">
              <select class="form-control" v-model="xb_id" @change="changeDep(xb_id)">
                <option :value="item.id" v-for="(item,index) in depList" :key="index">{{item.ybmc}}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">
              调整专业名称
              <i>*</i>
            </label>
            <div class="col-sm-9">
              <select
                class="form-control"
                v-model="zy_id"
                @change="changeMajor(zy_id)"
                @click="add"
              >
                <option
                  :value="item.id"
                  v-for="(item,index) in proList"
                  :key="index"
                >{{item.major_name}}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">
              更换专业原因
              <i>*</i>
            </label>
            <div class="col-sm-9">
              <textarea class="form-control" v-model="majorApp.content"></textarea>
            </div>
          </div>
          <div class="form-group">
              <label class="col-sm-3 control-label"></label>
              <div  class="col-sm-9 red" >
                  注： 专业调整仅有一次机会，请谨慎选择。如需再次调整，到校后联系学工部老师。
              </div>
          </div>
        </form>
        <div class="btn-box">
          <button
            type="button"
            class="btn btn-success btn-lg"
            data-toggle="modal"
            data-target="#myModal"
            v-if="recState == 1||recState == 3 || !recState"
          >提交</button>
        </div>
        <div class="btn-box">
          <button type="button" class="btn btn-info btn-lg" v-if="recState == 2" disabled>通过</button>
        </div>
        <div class="btn-box">
          <button type="button" class="btn btn-success btn-lg" v-if="recState == 4" disabled>拒绝</button>
        </div>
      </div>
    </div>
    <!-- 提示框   -->
    <tip :tip="tip" v-show="tipShow"></tip>
    <page-load v-if="flags"></page-load>
    <!-- 模态框 -->
    <div
      class="modal fade"
      id="myModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">提示框</h4>
          </div>
          <h4 class="modal-body">确定提交吗</h4>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="_submit">提交更改</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getProfessInfo, getProList, updateProfess } from "@/api/login.js";
import pageLoad from "../pageload/pageload";
let Base64 = require("js-base64").Base64;

export default {
  components: { pageLoad },
  data() {
    return {
      data: {}, //学生现专业信息
      majorApp: {}, //学生改专业的信息
      depList: [], //系部信息集合
      proList: [], //专业信息集合
      tipShow: false, //tip提示
      tip: "", //tip提示信息
      xb_id: 0, //系部id
      xb_name: "", //系部信息
      zy_id: 0, //专业id
      zy_name: "", //专业信息
      recState: 0, //返回节点信息
      flags: true
    };
  },
  created() {
    this._getProList();
  },
  methods: {
    //提示框方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    },
    _submit() {
      this.flags = true;
      this._updateProfess();
    },
    //更换专业信息申请
    _updateProfess() {
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        yxbm_name: this.xb_name,
        yxbm_id: this.xb_id,
        major_name: this.zy_name,
        yxbm_major_id: this.zy_id,
        content: this.majorApp.content
      };
      updateProfess(module)
        .then(res => {
          this.flags = false;
          if (res.status) {
            this.tipCtr(res.msg);
          } else {
            this.tipCtr(res.msg);
          }
        })
        .catch(err => {
          this.flags = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    add() {
      if (this.xb_id == undefined) {
        this.tipCtr("请选择系部");
      }
    },
    //切换专业
    changeMajor(item) {
      console.log(item);
      for (let i = 0; i < this.proList.length; i++) {
        if (this.proList[i].id == item) {
          this.zy_name = this.proList[i].major_name;
        }
      }
    },

    //获取系部信息
    _getProList() {
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      this.flags = true;
      getProList(module)
        .then(res => {
          this.flags = false;
          if (res.status) {
            this.depList = res.data;
            this._getProfessInfo();
          } else {
            this.tipCtr(res.msg);
          }
        })
        .catch(err => {
          this.flags = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //获取个人专业信息
    _getProfessInfo() {
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      getProfessInfo(module)
        .then(res => {
          this.data = res.data;
          if (res.status && res.data) {
            this.majorApp = res.majorApp;
            this.xb_id = res.majorApp.yxbm_id;
            this.zy_id = res.majorApp.yxbm_major_id;
            this.recState = res.recState;
            this.changeDep(this.xb_id);
          } else {
            this.majorApp.content = "";
            this.majorApp.yxbm_id = "";
            this.majorApp.yxbm_major_id = "";
            this.recState = 0;
            this.flags = false;
          }
        })
        .catch(err => {
          this.flags = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //切换系部
    changeDep(item) {
      this.flags = false;
      for (let i = 0; i < this.depList.length; i++) {
        if (this.depList[i].id == item) {
          this.xb_name = this.depList[i].ybmc;
          this.proList = this.depList[i].majorData;
        }
      }
    }
  }
};
</script>
<style scoped>
.left {
  width: 70%;
  padding: 30px 0;
  margin: 0 auto;
}
.left i {
  color: red;
  font-size: 16px;
  display: inline-block;
  margin-right: -10px;
}
textarea {
  min-height: 95px;
}

/***input 间距***/
form > div:last-child {
  margin-bottom: 0 !important;
}
.form-horizontal .form-group {
  margin: 0 0 20px;
}
/***input lable文字***/
.form-horizontal .control-label {
  padding-top: 8px;
  color: #333;
  font-size: 15px;
}
/***input***/
.form-control {
  height: 40px;
  color: #333;
  font-size: 14px;
}

.btn-box {
  text-align: center;
}
.btn-box button {
  margin-top: 50px;
  min-width: 40%;
}
.red {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/departmentInfo.vue